import { useSuspenseQuery } from '@tanstack/react-query';
import { categoryService } from '../../../api';

export const useOverviewQuery = (type: string) => {
  return useSuspenseQuery({
    queryKey: ['overview', type],
    queryFn: () => categoryService.getOverview(type),
  });
};
